var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14 10.694V5.306c0-.477-.254-.917-.667-1.155L8.667 1.457a1.334 1.334 0 00-1.334 0L2.667 4.151A1.334 1.334 0 002 5.306v5.389c0 .476.254.916.667 1.154l4.666 2.694c.413.238.921.238 1.334 0l4.666-2.694c.413-.238.667-.678.667-1.155z",
    stroke: "#21252C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.72V8M8 8l5.82-3.36M2.18 4.64L8 8",
    stroke: "#21252C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntity);
export default __webpack_public_path__ + "static/media/entity.2ae3e89e2f6189360ecbc1c4ed3a7529.svg";
export { ForwardRef as ReactComponent };